import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
// import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { BasicChartComponent } from '../animation-base-classes/basic-chart.component';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import * as d3 from 'd3';

@Component({
  selector: 'app-demo-scb-triptych-line-hor-steps',
  templateUrl: './demo-scb-triptych-line-hor-steps.component.html',
  styleUrls: ['./demo-scb-triptych-line-hor-steps.component.scss']
})
export class DemoSCBTriptychLineHorStepsComponent extends BasicChartComponent {

  private backgroundGroup;
  private slide01Group;
  private slide02Group;
  private slide03Group;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createLineScales(this.data, this.values);
    this.values['colorScheme'] = { 'value': { 0: '#FFFFFF', 1: '#FFFFFF' } };
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01Group.selectAll('*').remove();
    this.drawBackgroundSlide1(this.slide01Group, this.values);
    this.drawSCBLogo(this.slide01Group, this.values, 'slide1', this.values['logoX'], this.values['logoY'], this.values['logoWidth']);
    this.drawTopText(this.slide01Group, this.values);
    this.drawCenter3DText(this.slide01Group, this.values);
    this.drawBottomText(this.slide01Group, this.values);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02Group.selectAll('*').remove();
    this.drawBackgroundSlide2(this.slide02Group, this.values);
    this.drawSCBLogo(this.slide02Group, this.values, 'slide2', this.values['logoX'], this.values['logoY'], this.values['logoWidth']);
    this.drawTitleSlide2(this.slide02Group, this.values);
    this.drawSubTitleSlide2(this.slide02Group, this.values);
    this.drawLineHorSteps(this.slide02Group, this.values, this.data);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03Group.selectAll('*').remove();
    this.drawBackgroundSlide3(this.slide03Group, this.values);
    this.drawSCBLogo(this.slide03Group, this.values, 'slide3', 300, 300, 300);
    this.drawSCBWWW(this.slide03Group, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {
      // Slide 01
      let slide01AnimationTotal = new TimelineMax();
      let slide01AppearAnimation = new TimelineMax();
      this.animateSlide1(slide01AppearAnimation);
      slide01AppearAnimation.duration(2);
      slide01AnimationTotal.add(slide01AppearAnimation);
      let pauseSlide01 = new TimelineMax()
        .set({}, {}, 4);
      slide01AnimationTotal.add(pauseSlide01);
      let slide01SlideOutAnimation = new TimelineMax();
      slide01SlideOutAnimation.to(this.slide01Group.node(), 1, { x: -this.values['width'] });
      slide01AnimationTotal.add(slide01SlideOutAnimation);
      main.add(slide01AnimationTotal);
      // Slide 02
      let slide02AnimationTotal = new TimelineMax();
      let linesAnimation = new TimelineMax();
      this.animateNLines(linesAnimation, this.values, this.data);
      linesAnimation.duration(2);
      slide02AnimationTotal.add(linesAnimation);
      let pauseSlide02 = new TimelineMax()
        .set({}, {}, 4);
      slide02AnimationTotal.add(pauseSlide02);
      let slide02SlideOutAnimation = new TimelineMax();
      slide02SlideOutAnimation.to(this.slide02Group.node(), 1, { x: -this.values['width'] });
      slide02AnimationTotal.add(slide02SlideOutAnimation);
      main.add(slide02AnimationTotal);
      // Slide 03
      let slide03AnimationTotal = new TimelineMax();
      let logoAnimation = new TimelineMax();
      this.animateSCBLogo(logoAnimation, this.values, 'slide3');
      logoAnimation.duration(1);
      slide03AnimationTotal.add(logoAnimation);
      let pause01Slide03 = new TimelineMax()
        .set({}, {}, 2);
      slide03AnimationTotal.add(pause01Slide03);
      let textAnimation = new TimelineMax();
      this.textAnimation(textAnimation, this.values, 'slide3');
      textAnimation.duration(1);
      slide03AnimationTotal.add(textAnimation);
      let pause02Slide03 = new TimelineMax()
        .set({}, {}, 4);
      slide03AnimationTotal.add(pause02Slide03);
      main.add(slide03AnimationTotal);
    }

    this.animation = main;
    return this.animation;
  }

  public drawBackgroundSlide1(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['backgroundColorSlide1'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide2(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['backgroundColorSlide2'])
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['bannerHeight'])
      .attr('fill', values['bannerColorSlide2'])
      .attr('stroke', 'none');
  }

  public drawBackgroundSlide3(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['backgroundColorSlide3'])
      // .attr('fill', '#CACACA')
      .attr('stroke', 'none');
  }

  public drawArrow(selection, values) {
    let group = selection.append('g')
      .attr('transform', `translate(${values['iconX']} ${values['iconY']})`)
      .attr('id', `slide1-icon-${this.id}`);
    group.append('path')
      .attr('fill', values['iconColor'])
      .attr('opacity', values['iconOpacity'])
      .attr('stroke', 'none')
      .attr('d', 'M268.467778,119.653796 L153.560389,6.43501062 C149.20681,2.14480049 143.858499,0 137.500618,0 C131.029601,0 125.731985,2.14480049 121.613952,6.43501062 L6.70656313,119.653796 C2.23490281,124.059135 0,129.336769 0,135.481827 C0,141.510537 2.23737573,146.726039 6.70656313,151.132596 L19.9434937,164.173787 C24.1808447,168.578517 29.4766061,170.786059 35.8301597,170.786059 C42.1843315,170.786059 47.4788565,168.578517 51.7168257,164.173787 L103.610465,113.218176 L103.610465,235.655157 C103.610465,241.679604 105.815693,246.580787 110.22924,250.351396 C114.642786,254.11835 119.967605,256 126.202458,256 L148.795687,256 C155.033013,256 160.355359,254.117741 164.768905,250.351396 C169.182452,246.582005 171.391389,241.679604 171.391389,235.655157 L171.391389,113.218785 L223.284411,164.174396 C227.518052,168.579126 232.813195,170.786668 239.172931,170.786668 C245.40593,170.786668 250.762896,168.579126 255.231465,164.174396 L268.467159,151.133205 C272.821356,146.609693 275,141.394191 275,135.482436 C275.000618,129.453116 272.821974,124.177309 268.467778,119.653796 Z');
  }

  public drawLogoBackground(selection, values, border?: boolean) {
    let group = selection.append('g')
      .attr('id', `slide1-logo-group-${this.id}`);
    group.append('circle')
      .attr('cx', values['logoBackgroundX'])
      .attr('cy', values['logoBackgroundY'])
      .attr('r', values['logoBackgroundRadius'])
      .attr('fill', values['logoBackgroundColor'])
      .attr('stroke', border ? values['logoBorderColor'] : 'none')
      .attr('stroke-width', border ? values['logoBackgroundRadiusWidth'] : null);
    return group;
  }

  public drawSCBLogo(selection, values, id?: string, x?: number, y?: number, w?: number, h?: number) {
    const logoWidth = 563;
    const logoHeight = 638;
    let factor, actualLogoWidth, actualLogoHeight;

    if (w) {
      factor = w / logoWidth;
      actualLogoWidth = w;
      actualLogoHeight = logoHeight * factor;
    } else if (h) {
      factor = h / logoHeight;
      w = logoWidth * factor;
      actualLogoWidth = logoWidth * factor
      actualLogoHeight = h;
    } else {
      factor = 1;
      actualLogoWidth = logoWidth;
      actualLogoHeight = logoHeight;
    }

    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);

    // let purple = '#813989';

    let outerGroup = selection.append('g')
      .attr('id', `scb-logo-outer-group-${idValue}`)
      .attr('transform', `translate(${x - actualLogoWidth / 2} ${y - actualLogoHeight / 2})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `scb-logo-inner-group-${idValue}`)
      .attr('transform', `scale(${factor} ${factor})`);

    let s = innerGroup.append('path')
      .attr('id', `scb-logo-s-${idValue}`)
      .attr('class', `scb-logo-${idValue}`)
      .attr('fill', values['logoLetterColor'] || '#FFFFFF')
      .attr('d', 'M75.94646,603.06261 C39.188623,597.33618 9.862297,574.24175 4.1354475,546.51156 C3.23696,542.16092 2.8977225,514.99951 3.1172475,464.98721 L3.44646,389.98721 L37.10981,389.65387 C63.20806,389.39544 70.99901,389.67637 71.778172,390.90387 C72.330923,391.77471 72.791798,424.71827 72.802323,464.11179 C72.823193,542.43841 72.55766,539.51259 80.233185,545.97111 C88.302185,552.76073 101.50212,550.72913 107.93665,541.70728 L110.94646,537.48721 L111.34592,486.23721 C111.78232,430.24812 111.21572,422.86374 105.22007,406.4014 C100.25032,392.75585 95.375522,384.28003 73.492848,351.23721 C34.006623,291.61302 15.765823,260.02103 8.4458975,238.57969 C2.2769225,220.50968 -0.8049025,179.08486 1.4594225,144.6701 C2.28511,132.12069 3.79161,118.6628 4.8071975,114.76367 C11.19846,90.225973 34.005297,70.689235 65.94646,62.390698 C78.976397,59.005423 106.2372,59.282398 119.69646,62.936798 C149.61714,71.060735 170.66208,88.539223 178.60507,111.86221 C180.77766,118.24156 180.94646,123.51351 180.94646,184.98721 L180.94646,251.23721 L146.57146,251.23721 L112.19646,251.23721 L111.57146,185.61221 C110.88357,113.38359 111.19181,116.11219 103.02846,109.98721 C98.15776,106.33272 86.096073,106.48885 80.788072,110.2751 C72.62106,116.10067 72.194547,118.48017 72.213485,158.11221 C72.228735,189.94934 72.516872,195.03176 74.92371,205.91246 C77.71811,218.54521 85.22071,235.84789 96.202973,254.98721 C103.28087,267.32221 139.25026,325.13639 154.36431,348.47087 C179.93731,387.95284 182.04045,399.08441 181.33786,491.23721 C180.9259,545.27087 180.8679,546.36317 178.03695,553.40664 C168.82077,576.33665 147.4711,593.62817 119.69646,600.65776 C108.1248,603.58647 86.82466,604.7573 75.94646,603.06261 Z');

    let c = innerGroup.append('path')
      .attr('id', `scb-logo-c-${idValue}`)
      .attr('class', `scb-logo-${idValue}`)
      .attr('fill', values['logoLetterColor'] || '#FFFFFF')
      .attr('d', 'M261.57146,636.33122 C241.80776,632.20478 221.58567,621.23735 210.482,608.62291 C203.10855,600.24624 196.84201,586.833 195.35168,576.23721 C193.65841,564.19844 193.67775,74.337385 195.37198,62.48721 C200.50789,26.564285 237.77912,0.61221 284.23414,0.61221 C327.30896,0.61221 364.74945,24.743235 371.50881,56.86221 C372.55033,61.81131 372.84931,89.649348 372.57606,156.23721 L372.19647,248.73721 L338.53312,249.07055 C312.43487,249.32898 304.64392,249.04805 303.86476,247.82055 C303.31201,246.94971 302.85113,205.67977 302.84061,156.10956 L302.82151,65.981922 L299.9841,61.73456 C291.97048,49.73891 274.69405,50.468573 267.2641,63.11646 C264.70075,67.479985 264.69588,67.898135 264.31484,316.23721 C264.04385,492.84934 264.32944,566.83572 265.29982,571.36135 C267.3755,581.04228 274.51677,586.86601 284.30183,586.85753 C290.82903,586.85153 296.90828,583.42034 300.32826,577.81114 C302.74684,573.84435 302.81228,571.3355 302.81683,482.41362 C302.82083,411.33315 303.16786,390.61663 304.38401,388.95435 C305.80067,387.01801 309.0383,386.84987 339.07151,387.15293 L372.19651,387.48721 L372.52597,482.48721 C372.84492,574.45251 372.77547,577.75155 370.35185,585.76226 C363.64507,607.92986 342.46589,626.24175 314.07151,634.4232 C302.10513,637.87115 273.86303,638.89756 261.57151,636.33122 L261.57146,636.33122 Z');


    let b = innerGroup.append('path')
      .attr('id', `scb-logo-b-${idValue}`)
      .attr('class', `scb-logo-${idValue}`)
      .attr('fill', values['logoLetterColor'] || '#FFFFFF')
      .attr('d', 'M421.51758,64.546875 C400.4789,64.52216 390.49258,64.851716 389.14258,65.574219 L386.57227,66.949219 L386.57227,329.19727 C386.57227,473.43349 386.94596,591.82098 387.4043,592.2793 C387.86262,592.73764 414.74536,593.11133 447.14258,593.11133 C512.10442,593.11133 513.86196,592.94117 528.31055,585.25977 C542.24815,577.85001 553.181,564.95667 559.36328,548.63672 C562.15813,541.25891 562.16757,540.969 562.54102,452.25977 C562.95077,354.92483 562.9339,354.66204 555.63281,339.625 C550.64293,329.34804 538.38309,316.87407 527.81055,311.31836 C523.00388,308.79253 519.07698,306.33556 519.08398,305.85742 C519.09115,305.37928 522.60677,303.35607 526.89648,301.36133 C542.87271,293.93229 557.1235,275.41464 561.02344,257.01562 C563.62324,244.75015 563.55657,136.19224 560.94141,123.73633 C555.37552,97.22612 534.77292,75.331546 507.76562,67.224609 C502.02632,65.501808 492.30314,65.099775 446.33008,64.6875 C436.77173,64.601784 428.53047,64.555113 421.51758,64.546875 Z M457.19727,117.48633 L466.66602,117.48633 C477.42739,117.48633 482.49312,119.96849 487.93359,127.90625 L490.94727,132.30078 L491.30078,198.64453 C491.6114,256.9611 491.41165,265.6236 489.65625,270.24219 C487.24198,276.59429 480.82558,282.50771 474.41797,284.28711 C468.8425,285.83543 460.34586,285.98612 458.125,284.57617 C456.884,283.78796 456.621,266.14235 456.875,200.5332 L457.19727,117.48633 Z M457.19727,338.73633 L468.02148,338.73633 C478.26799,338.73633 479.1032,338.94416 483.64648,342.61914 C486.28641,344.75454 489.57227,348.4108 490.94727,350.74414 C493.38067,354.87361 493.44727,357.23382 493.44727,439.36133 C493.44727,485.76758 493.01579,525.27432 492.49023,527.15234 C491.16701,531.88068 484.29676,539.39594 479.44336,541.42383 C474.21503,543.60837 457.96698,543.69911 457.14648,541.54883 C456.8186,540.68945 456.69544,494.70508 456.87305,439.36133 L457.19727,338.73633 Z');
  }

  public drawCenter3DText(selection, values) {
    let shadow = '#1E00BE'
    let shadowString = this.createShadowString('down-left', 40, 1, shadow);
    // console.log(shadowString);
    let text = selection.append('text')
      .attr('id', `center-text-${this.id}`)
      .attr('x', values['centerTextSlide1X'])
      .attr('y', values['centerTextSlide1Y'])
      .attr('fill', values['centerTextSlide1FontColor'])
      .attr('font-size', values['centerTextSlide1FontSize'])
      .attr('font-weight', values['centerTextSlide1FontWeight'])
      .attr('text-anchor', values['centerTextSlide1Anchor'])
      .attr('font-family', 'Steelfish')
      .attr('style', shadowString)
      .text(values['centerTextSlide1']);
  }

  public drawTopText(selection, values) {
    // let text = selection.append('text')
    //   .attr('id', `top-text-${this.id}`)
    //   .attr('x', values['topTextSlide1X'])
    //   .attr('y', values['topTextSlide1Y'])
    //   .attr('fill', values['topTextSlide1FontColor'])
    //   .attr('font-size', values['topTextSlide1FontSize'])
    //   .attr('font-weight', values['topTextSlide1FontWeight'])
    //   .attr('text-anchor', values['topTextSlide1Anchor'])
    //   .attr('font-family', 'Steelfish')
    //   .text(values['topTextSlide1']);

    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['topTextSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['topTextSlide1FontSize'] * values['topTextSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['topTextSlide1Y'];
    let group = selection.append('g')
      .attr('id', `top-text-${this.id}`)
    let text = group.append('text')
      .attr('x', values['topTextSlide1X'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['topTextSlide1FontColor'])
      .attr('font-size', values['topTextSlide1FontSize'])
      .attr('font-weight', values['topTextSlide1FontWeight'])
      .attr('font-family', 'Steelfish')
      .attr('text-anchor', values['topTextSlide1Anchor']);

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['topTextSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group
  }

  public drawBottomText(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['bottomTextSlide1'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['bottomTextSlide1FontSize'] * values['bottomTextSlide1LineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y = values['bottomTextSlide1Y'];
    let group = selection.append('g')
      .attr('id', `bottom-text-${this.id}`)
    let text = group.append('text')
      .attr('x', values['bottomTextSlide1X'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['bottomTextSlide1FontColor'])
      .attr('font-size', values['bottomTextSlide1FontSize'])
      .attr('font-weight', values['bottomTextSlide1FontWeight'])
      .attr('font-family', 'Poly Regular')
      .attr('text-anchor', values['bottomTextSlide1TextAnchor']);

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('x', values['bottomTextSlide1X'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
    return group
  }

  public createShadowString(direction: 'up-right' | 'down-right' | 'down-left' | 'down-right', nr: number, step: number, color: string) {
    let shadowString = _.reduce(_.range(0, nr, step), (accumulator, value) => {
      let n = value + step;
      let x = direction === 'up-right' || direction === 'down-right' ? `${n}px` : `-${n}px`;
      let y = direction === 'down-right' || direction === 'down-left' ? `${n}px` : `-${n}px`;
      let result = accumulator + `${x} ${y} ${color}`;
      if (n !== nr) {
        result = result + ', ';
      } else {
        result = result + ';';
      }
      return result;
    }, 'text-shadow: ');
    return shadowString;
  }

  public drawSCBWWW(selection, values) {
    let line1 = selection.append('text')
      .attr('id', `website-${this.id}`)
      .attr('x', 300)
      .attr('y', 220)
      .attr('fill', '#FFFFFF')
      .attr('font-size', 48)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'bold')
      .attr('font-family', 'Steelfish')
      .text('http://www.scb.se/');
    let line2 = selection.append('text')
      .attr('id', `nyheter-${this.id}`)
      .attr('x', 300)
      .attr('y', 280)
      .attr('fill', '#FFFFFF')
      .attr('font-size', 48)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'bold')
      .attr('font-family', 'Steelfish')
      .text('@SCB_nyheter');
    let line3 = selection.append('text')
      .attr('id', `statsweden-${this.id}`)
      .attr('x', 300)
      .attr('y', 340)
      .attr('fill', '#FFFFFF')
      .attr('font-size', 48)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'bold')
      .attr('font-family', 'Steelfish')
      .text('@StatsSweden');
    let line4 = selection.append('text')
      .attr('id', `sverigeisiffror-${this.id}`)
      .attr('x', 300)
      .attr('y', 400)
      .attr('fill', '#FFFFFF')
      .attr('font-size', 48)
      .attr('text-anchor', 'middle')
      .attr('font-weight', 'bold')
      .attr('font-family', 'Steelfish')
      .text('@sverigeisiffror');
  }

  public drawTitleSlide2(selection, values) {
    let text = selection.append('text')
      .attr('x', values['titleTextSlide2X'])
      .attr('y', values['titleTextSlide2Y'])
      .attr('fill', values['titleTextSlide2FontColor'])
      .attr('font-size', values['titleTextSlide2FontSize'])
      .attr('font-weight', values['titleTextSlide2FontWeight'])
      .attr('font-family', 'Steelfish')
      .attr('text-anchor', 'middle')
      .text(values['titleTextSlide2']);
  }

  public drawSubTitleSlide2(selection, values) {
    let line1 = selection.append('text')
      .attr('x', values['subtitleTextSlide2X'])
      .attr('y', values['subtitleTextSlide2Line1Y'])
      .attr('fill', values['subtitleTextSlide2FontColor'])
      .attr('font-size', values['subtitleTextSlide2FontSize'])
      .attr('font-weight', values['subtitleTextSlide2FontWeight'])
      .attr('font-family', 'Poly Regular')
      .attr('text-anchor', 'middle')
      .text(values['subtitleTextSlide2Line1']);
    // let line2 = selection.append('text')
    //   .attr('x', values['subtitleTextSlide2X'])
    //   .attr('y', values['subtitleTextSlide2Line2Y'])
    //   .attr('fill', values['subtitleTextSlide2FontColor'])
    //   .attr('font-size', values['subtitleTextSlide2FontSize'])
    //   .attr('font-weight', values['subtitleTextSlide2FontWeight'])
    //   .attr('font-family', 'Poly Regular')
    //   .attr('text-anchor', 'middle')
    //   .text(values['subtitleTextSlide2Line2']);
  }

  public drawLineHorSteps(selection, values, data) {
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values);
    this.drawNLines(selection, values, data);
  }

  public animateSlide1(timeline, values?) {
    timeline.from(`#top-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#center-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#bottom-text-${this.id}`, 1, { opacity: 0 }, 'startAnimationSlide01');
    timeline.from(`#scb-logo-outer-group-slide1-${this.id}`, 0.5, { opacity: 0 }, 'startAnimationSlide01');
  }

  public animateSCBLogo(timeline, values?, id?) {
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // `scb-logo-s-${idValue}`
    // let s = `scb-logo-s-${idValue}`;
    // console.log(s);
    timeline.from(`#scb-logo-s-${idValue}`, 1, { opacity: 0, scale: 0, transformOrigin: '50% 50%' }, 'startLogoAnimationS');
    timeline.from(`#scb-logo-c-${idValue}`, 1, { opacity: 0, scale: 0, transformOrigin: '50% 50%' }, 'startLogoAnimationC');
    timeline.from(`#scb-logo-b-${idValue}`, 1, { opacity: 0, scale: 0, transformOrigin: '50% 50%' }, 'startLogoAnimationB');
  }

  public textAnimation(timeline, values?, id?) {
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
      // .attr('id', `website-${this.id}`)
      // .attr('id', `nyheter-${this.id}`)
      // .attr('id', `statsweden-${this.id}`)
      // .attr('id', `sverigeisiffror-${this.id}`)
    timeline.to(`#scb-logo-outer-group-${idValue}`, 1, { opacity: 0 }, 'startTextAnimation1')
      .from(`#sverigeisiffror-${this.id}`, 1, { y: -this.values['height'] }, '+=1.25')
      .from(`#statsweden-${this.id}`, 1, { y: -this.values['height'] }, '+=0.25')
      .from(`#nyheter-${this.id}`, 1, { y: -this.values['height'] }, '+=0.25')
      .from(`#website-${this.id}`, 1, { y: -this.values['height'] }, '+=0.25');
  }

}




// WEBPACK FOOTER //
// ./src/app/animations/demo-scb-triptych-line-hor-steps/demo-scb-triptych-line-hor-steps.component.ts